import { Url } from 'url'
import { useFetch } from 'use-http'
import { getAbsoluteServerUrl } from '../config/config'

type Category = { id: number; name: string; description: string; created_at: Date; updated_at: Date; attachment: { url: string; }[]}

export function useGetCategories() {
  return useFetch<Category[]>(getAbsoluteServerUrl('/categories'), { responseType: 'json' }, [])
}
